import React, { useEffect, useRef, useState } from 'react';
import useInView, { archetypeDescriptions, bogglerWords, fetchGuideTypes, getGuideTypeLabel } from '../utils/index';
import { textTranslations } from './text-translations';
import { useLanguage } from "../LanguageContext";
import SelectWhatsappModal from '../SelectWhatsappModal';
import Header from '../Header';
import Footer from '../Footer';

import mapboxgl from "mapbox-gl"
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY

const Ghosted = (props) => {

  const { language } = useLanguage();
  const [showSelectWhatsappModal, setShowSelectWhatsappModal] = useState(false);
  const [map, setMap] = useState(undefined)
  const mapLoaded = useRef(false)
  const sliderContainerRef = useRef(null);
  const [wordIndex, setWordIndex] = useState(0)
  const [phraseIndex, setPhraseIndex] = useState(0)
  const [sliderGuides, setSliderGuides] = useState([])
  const [visibleIndices, setVisibleIndices] = useState([0,1,2])
  // Animated when in view
  const [howRef, howInView] = useInView({threshhold: 0.5})
  const [footerCTARef, footCtaInView] = useInView({threshhold: 0.1})
  // hero section words
  const words = bogglerWords
  const aConversationCanPhrases = ["change your perspective.", "give you an idea.", "get things started.", "lead to something special."]
  const conversationTopics = [
    "family",
    "work",
    "food",
    "faith",
    "love",
    "loss",
    "life changes",
    "common ground"
  ]

  const initializeMap = async () => {
  if (!map) {
    let theMap = undefined
    let zoom = 2.1
    // create map
    const createTheMap = new Promise((resolve, reject) => {
      try {
        theMap = new mapboxgl.Map({
          container: 'hero-map', // container ID
          projection: 'globe',
          style: 'mapbox://styles/redappledigitalhealth/cmlfvmstf00e001sl2daj9d7i', // style URL
          center: [-51.3515625,36.9703356], // starting position [lng, lat]
          zoom: zoom, // starting zoom
        })
        resolve(theMap)
      } catch (error) {
        console.log(error)
        resolve(false)
      }
    })
    // The Boggler Look
    createTheMap.then((theMap) => {

        theMap.on('style.load',() => {
            theMap.setFog({
                color: '#ffffff', // Lower atmosphere
                'high-color': 'transparent', // Upper atmosphere
                'horizon-blend': 0.05, // Atmosphere thickness (default 0.2 at low zooms)
                'space-color': 'transparent', // Background color
                'star-intensity': 0.0 // Background star brightness (default 0.35 at low zoooms )
            });
            let padding = {left: 250, bottom: 100} 
            theMap.easeTo({padding: padding})
        })

      setMap(theMap)
              function spinGlobe() {
                  const zoom = theMap.getZoom();
                  const secondsPerRevolution = 240;
                  const maxSpinZoom = 2;
                  const slowSpinZoom = 0;
                  
                      let distancePerSecond = 360 / secondsPerRevolution;
                      if (zoom > slowSpinZoom) {
                          // Slow spinning at higher zooms
                          const zoomDif =
                              (maxSpinZoom - zoom) / (maxSpinZoom - slowSpinZoom);
                          distancePerSecond *= zoomDif;
                      }
                      const center = theMap.getCenter();
                      center.lng -= distancePerSecond;
                      // Smoothly animate the map over one second.
                      // When this animation is complete, it calls a 'moveend' event.
                      theMap.easeTo({ center, duration: 1000, easing: (n) => n });
                  
              }
              theMap.on('moveend', spinGlobe)
			})
		}
	}

  const getShortDesc = (guideType) => {
    const shortDescriptions = archetypeDescriptions
    let foundType = shortDescriptions.find(type => type.title.toLowerCase().replace(/\s+/g, "-") == guideType.hyphenated_title)
    return foundType.desc
  }

  const openPickGuideForArchetype = (archetype) => {
    if(!archetype) return;
    window.open(`/pick-guide?archetype=${encodeURIComponent(archetype)}`, '_self');
  }

  useEffect(() => {
    // sigletons
    if (mapLoaded.current) return
    mapLoaded.current = true
    // init map
    initializeMap()

    // set animated element intervals
    const interval = setInterval(() => {
      setWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000); // 2 seconds
    
    const phraseInterval = setInterval(() => {
      setPhraseIndex((prevIndex) => (prevIndex + 1) % aConversationCanPhrases.length);
    }, 3000); // 3 seconds

        // fetch guidetypes
      (async () => {
        let archetypes = await fetchGuideTypes();
        archetypes = archetypes.reverse()
        setSliderGuides(archetypes);
      })()
  }, [])
  
  return (
    <>
      <Header />
      <SelectWhatsappModal show={showSelectWhatsappModal} onClose={() => setShowSelectWhatsappModal(false)} phoneNumber="+94741302208" />
      <section className="main-body-section home">
          <div className='mobile-header-globe'>
            <img src='img/guide-cyber-monk.png' alt='guide icon'/>
            <img src='img/guide-peer-sister.png' alt='guide icon'/>
            <img src='img/guide-peer-brother.png' alt='guide icon'/>
          </div>
          
          <div className="boggler-hero-section">
            <div className="the-boggler-intro">
              <span className='cloud1'>
                <img src='img/cloud1.svg' />
              </span>
              
              <h1 className="lucky-font hero-title">
                <span className="hero-title-bg">{textTranslations("title", language)}</span>
              </h1>
              <p className="hero-intro-line">
                Call a real person, near or far<br/>
                and choose the &nbsp;
                <span>
                  <div className='words-slider'>
                    <div className='words-container' style={{transform: `translateY(-${wordIndex * 19}px)`,}}>
                      
                      {words.map((word, i) => (
                        <div key={i} className='words-word'>
                          {word}
                        </div>
                      ))}

                    </div>
                  </div>
                </span> 
                <br/>you need today
              </p>
              <p className="hero-subcopy">
                The Boggler is a donation-based way to meet mental health guides, peer mentors,
                elders, devotees, retirees, life coaches, and digital friends from around the world.
                Start with a private WhatsApp introduction and talk one-on-one with someone willing to listen.
              </p>
              <div className="boggler-cta-container" onClick={() => setShowSelectWhatsappModal(true)}>
                <button><img src='img/whatsapp.svg' />Start on WhatsApp</button>
                <button
                  className='pick-guide-cta'
                  onClick={(event) => {
                    event.stopPropagation();
                    window.open('/pick-guide', '_self');
                  }}
                >
                  Browse Guides
                </button>
                <p>Takes 30 seconds * No commitment</p>
                <p className="hero-cta-note">Donation based * Guides around the world</p>
              </div>
              
              <span className='cloud2'>
                <img src='img/cloud2.svg' />
              </span>
            </div>

            {/* THE GLOBE */}
            
              <div className='hero-map' id='hero-map'>
                <span className='guide-pop s1'>
                  <img src='img/guide-cyber-monk.png' alt='guide icon'/>
                </span>
                <span className='guide-pop s2'>
                  <img src='img/guide-peer-sister.png' alt='guide icon'/>
                </span>
                <span className='guide-pop s3'>
                  <img src='img/guide-peer-brother.png' alt='guide icon'/>
                </span>
              </div>
            

          </div>
          <div className="ocean">
            <div className="wave"></div>
            <div className="wave wave2"></div>
          </div>
        </section>

        <section className='main-body-section hero-how-it-works'>

          <span className='cloud3'>
            <img src='img/cloud1.svg' />
          </span>

          <h2>How It Works</h2>
          <div className={`the-steps${howInView ? ' fade' : ''}`} ref={howRef}>

            <div className='step'>
              <strong>SIGN UP</strong>
              <div className='card'>
                <span className='icon'>
                  <img src='img/whatsapp.svg' />
                </span>
                <p>
                  Sign up on WhatsApp
                  to get started. Share what kind of conversation or support would help today.
                </p>
              </div>
            </div>

            <div className='step-arrow'></div>

            <div className='step'>
              <strong>CHOOSE</strong>
              <div className='card'>
                <span className='icon'>
                  <img src='img/globe.svg' />
                </span>
                <p>
                  Find someone interesting to talk to. Guides may be coaches, elders, devotees,
                  retirees, peer mentors, or digital friends.
                </p>
              </div>
            </div>
            
            <div className='step-arrow'></div>

            <div className='step'>
              <strong>CALL</strong>
              <div className='card'>
                <span className='icon'>
                  <img src='img/talk.svg' />
                </span>
                <p>
                  Schedule a one-on-one via WhatsApp. Continue with a call. Support your guide
                  with a donation if you can.
                </p>
              </div>
            </div>
          
            <span className='cloud4'>
              <img src='img/cloud3.svg' />
            </span>

          </div>
        </section>
        <section className='main-body-section connection-topics'>
          <div className='connection-topics-inner'>
            <h2 className="text-white">Talk About Real Life</h2>
            <p className="text-white">
              Share a story, ask for perspective, or learn what life is like somewhere else.
              The point is to find an ear: to talk about the ordinary and important things
              people carry, and maybe make a friend along the way.
            </p>
            <div className='topic-chip-row'>
              {conversationTopics.map(topic => (
                <span className='topic-chip' key={topic}>{topic}</span>
              ))}
            </div>
          </div>
        </section>
        <section className='main-body-section archetypes'>

            <span className='cloud6'>
              <img src='img/cloud2.svg' />
            </span>

            <h2>Archetypes</h2>
            <p className='section-lede'>
              Guides on The Boggler are donation-based listeners from many walks of life:
              people with faith, work, family, hardship, joy, mistakes, and perspective to share.
            </p>

            <span className='cloud5'>
              <img src='img/cloud1.svg' />
            </span>
        </section>
        <section className='main-body-section footer-cta' style={{backgroundColor: '#fdf6e3', position: 'relative', paddingTop: 0}}>
      
          <div className={`footer-cta-container${footCtaInView ? ' fade' : ''}`}  ref={footerCTARef}>
            
            <h2 style={{color: "#333"}}>
              A single conversation can
              <div>
                <div className='phrase-slider' style={{color: "#333"}}>
                    <div className='phrase-container' style={{transform: `translateY(-${phraseIndex * (window.innerWidth > 768 ? 52 : 26)}px)`,}}>
                      
                      {aConversationCanPhrases.map((phrase, i) => (
                        <div key={i} className='phrase'>
                          {phrase}
                        </div>
                      ))}
                    </div>
                </div>
              </div>
            </h2>
            <p style={{color: "#333"}}><i>Safe.</i> <i>Private.</i> <i>Human.</i></p>
            <div className="signoff-container">
                <div className={`boggler-cta-container`} onClick={() => setShowSelectWhatsappModal(true)}>
                  <button><img src='img/whatsapp.svg' />Start on WhatsApp</button>
                  <button
                    className='pick-guide-cta'
                    onClick={(event) => {
                      event.stopPropagation();
                      window.open('/pick-guide', '_self');
                    }}
                  >
                    Browse Guides
                  </button>
                  <ul className={'reveal'}>
                    <li>All guides verified</li>
                    <li>Private one-on-one calls</li>
                    <li>Leave anytime</li>
                    <li>No bots, No algorithms</li>
                  </ul>
                  <p className='donation-note'>Support is optional and donation based when a conversation helps.</p>
                </div>

              </div>
              <div className='footer-globe'></div>
            </div>
        </section>
        <Footer />
    </>
  );
}

export default Ghosted;
